import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * useSiteContent — fetches editable CMS content from
 * /api/public/site-content and merges over caller-provided defaults.
 *
 * Every page that renders marketing copy should call this hook with
 * hard-coded defaults, then read from the returned merged object. If the
 * fetch fails or the CMS key is unset, defaults apply — the page never
 * looks broken.
 */
export default function useSiteContent(defaults = {}) {
    const [content, setContent] = useState(defaults);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        let cancelled = false;
        api.get("/../public/site-content")
            .then((r) => {
                if (cancelled) return;
                const cms = r.data || {};
                // Shallow-merge each top-level key so an unset CMS section
                // falls back to defaults intact.
                const merged = { ...defaults };
                for (const [k, v] of Object.entries(cms)) {
                    if (v && typeof v === "object" && !Array.isArray(v) && merged[k] && typeof merged[k] === "object" && !Array.isArray(merged[k])) {
                        merged[k] = { ...merged[k], ...v };
                    } else if (v !== undefined && v !== null && v !== "") {
                        merged[k] = v;
                    }
                }
                setContent(merged);
            })
            .catch(() => {})
            .finally(() => { if (!cancelled) setLoaded(true); });
        return () => { cancelled = true; };
    }, []);

    return { content, loaded };
}
